import { useState } from 'react';
import { verileriIndir } from './veriIndir';

/** "Verilerimi indir" düğmesinin durumu: indiriliyor + hata metni. */
export function useVeriIndir() {
  const [indiriliyor, setIndiriliyor] = useState(false);
  const [hata, setHata] = useState<string | null>(null);

  const indir = async () => {
    setIndiriliyor(true);
    setHata(null);
    try {
      await verileriIndir();
    } catch (e) {
      setHata(e instanceof Error && e.message ? e.message : 'İndirme başarısız. Tekrar deneyin.');
    } finally {
      setIndiriliyor(false);
    }
  };

  return { indir, indiriliyor, hata };
}
